<template>
  <div>
    <UIBox
      :title="
        (mode === 'edit' ? 'แก้ไข'
        : mode === 'add' ? 'เพิ่ม'
        : '') + 'ข้อมูลอาจารย์'
      "
      :size="{ height: '65' }"
      :actions="actions"
    >
      <template slot="top">
      </template>

      <template slot="tools">
        <div class="btn-back" @click="$router.back()">
          <vs-icon icon="keyboard_arrow_left"></vs-icon>
          <span>ย้อนกลับ</span>
        </div>
      </template>

      <div v-if="data.newProfile">
        <div class="warning" v-if="!methods.isAllRequirementPasses()">
          <span>จำเป็นต้องกรอกข้อมูลให้ครบถ้วน</span>
          <!-- <template v-for="(passed, field) in data.warning">
            <span :key="field" v-if="!passed">{{ field }} </span>
          </template> -->
        </div>
        <div class="ready" v-else>
          <span>พร้อมบันทึกข้อมูล</span>
        </div>
        <vs-collapse type="margin">
          <vs-collapse-item :open="true">
            <div slot="header">
              <vs-icon class="section-icon" icon="face" />
              <span class="section-title">ข้อมูลส่วนตัว</span>
            </div>

            <TeacherPersonalData :methods="methods" />

          </vs-collapse-item>

          <vs-collapse-item :open="true">
            <div slot="header">
              <vs-icon class="section-icon" icon="class" />
              <span class="section-title">ข้อมูลอื่นๆ</span>
            </div>

            <TeacherAcademicData :methods="methods"/>

          </vs-collapse-item>

          <vs-collapse-item :open="true">
            <div slot="header">
              <vs-icon class="section-icon" icon="stay_current_portrait" />
              <span class="section-title">ข้อมูลการติดต่อ</span>
            </div>

            <TeacherContactData :methods="methods" />

          </vs-collapse-item>
        </vs-collapse>
      </div>
      <div v-else>
        No Data
      </div>
    </UIBox>
  </div>
</template>

<script>
  import UIBox from "@/components/common-ui/content-box/index.vue";

  import TeacherPersonalData from "./subcomponents/teacher-personal-data.vue";
  import TeacherAcademicData from "./subcomponents/teacher-academic-data.vue";
  import TeacherContactData from "./subcomponents/teacher-contact-data.vue";

  export default {
    components: {
      UIBox,
      TeacherPersonalData,
      TeacherAcademicData,
      TeacherContactData
    },
    props: {
      data: Object,
      methods: Object,
      actions: Object,
      mode: String
    },
    computed: {
      fullname() {
        return this.data.profile['prefix'] ? this.data.profile['prefix']['nameLocal'] + ' ' : ''  +
        this.data.profile['nameLocal'] ? this.data.profile['nameLocal'] + ' ' : ''
          + this.data.profile['firstNameLocal'] + ' '
          + this.data.profile['lastNameLocal']
      }
    },
    mounted() {
      this.methods.checkRequiredFiled();
      this.$forceUpdate();
    }
  }
</script>

<style lang="scss">
  .btn-back {
    display: inline-flex;
    width: max-content;
    padding: 4px 8px;

    & span {
      text-transform: uppercase;
      font-weight: 100;
      font-size: 1.3rem;
    }

    & i {
      font-size: 2rem;
    }
  }

  .section-icon {
    font-size: 3rem;
  }

  .section-title {
    font-size: 1.4rem;
    line-height: 1rem;
    margin-left: 10px;
  }

  .inline {
    display: inline-flex;
  }

  .-label {
    font-size: 1.2rem;
    line-height: 2rem;
    margin-right: 20px;
    margin-left: 10px;
    align-items: baseline;
  }
</style>
